import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { UserCircleIcon, BellIcon, Bars3Icon } from '@heroicons/react/24/outline';
import { useAuthStore } from '../../store/authStore';
import { signOut } from '../../services/auth';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

interface HeaderProps {
  onMenuClick?: () => void;
}

export const Header = ({ onMenuClick }: HeaderProps) => {
  const user = useAuthStore(state => state.user);
  const setUser = useAuthStore(state => state.setUser);
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut();
      setUser(null);
      toast.success('Sesión cerrada correctamente');
      navigate('/');
    } catch (error) {
      toast.error('Error al cerrar sesión');
    }
  };

  return (
    <header className="bg-white border-b border-gray-200">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            {/* Botón de menú para móviles */}
            {onMenuClick && (
              <button 
                className="md:hidden mr-4 text-gray-500 hover:text-gray-700"
                onClick={onMenuClick}
              >
                <Bars3Icon className="h-6 w-6" />
              </button>
            )}
            
            <h1 className="text-xl font-medium text-gray-900 truncate">
              Panel de Administración
            </h1>
          </div>
          
          <div className="flex items-center space-x-4">
            <button className="text-gray-400 hover:text-gray-500">
              <BellIcon className="h-6 w-6" />
            </button>
            
            <Menu as="div" className="relative">
              <div>
                <Menu.Button className="flex items-center space-x-3">
                  {/* En móviles solo mostramos el icono */}
                  <span className="hidden sm:inline-block text-sm font-medium text-gray-700">{user?.name}</span>
                  <span className="hidden sm:inline-block text-sm text-gray-500">{user?.role === 'admin' ? 'Administrador' : 'Propietario'}</span>
                  <UserCircleIcon className="h-8 w-8 text-gray-400" />
                </Menu.Button>
              </div>
              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items className="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                  {/* Mostrar info del usuario en el menú en móviles */}
                  <div className="sm:hidden px-4 py-2 border-b border-gray-100">
                    <p className="text-sm font-medium text-gray-700">{user?.name}</p>
                    <p className="text-xs text-gray-500">{user?.role === 'admin' ? 'Administrador' : 'Propietario'}</p>
                  </div>
                  <Menu.Item>
                    {({ active }) => (
                      <button
                        onClick={handleLogout}
                        className={`${
                          active ? 'bg-gray-100' : ''
                        } block w-full text-left px-4 py-2 text-sm text-gray-700`}
                      >
                        Cerrar Sesión
                      </button>
                    )}
                  </Menu.Item>
                </Menu.Items>
              </Transition>
            </Menu>
          </div>
        </div>
      </div>
    </header>
  );
};